import "./Main.css";
import BreadCrumb from "../breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Dashboard from "../../assets/images/Dashboard.svg";

const Main = () => {
  const currentUser = useSelector((state) => state?.auth?.user);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <main>
      <BreadCrumb name="Dashboard"></BreadCrumb>
      <div className="main__container">
        <div className="main__tile_heading">
          Dashboard
        </div>
        {currentUser?.Value?.isSuperAdmin && (
          <div className="container-fluid">
            <div className="cus-page-content-sec">
              <img src={Dashboard} alt="Dashboard" className="showDashboard" />
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default Main;
